import { moment, dateFormat, monthFormat } from './moment.js'

const toMoney = (value, hasCurrency = true, maxDigits = 0) => {
  const nilai = parseFloat(value || 0)
  let numData = nilai.toLocaleString('en-US', {
    maximumFractionDigits: maxDigits,
    style: 'currency',
    currency: 'IDR'
  })

  numData = numData.replace('IDR', '')

  if (hasCurrency === false) {
    return nilai < 0 ? '(' + numData + ')' : numData
  } else {
    return 'IDR ' + (nilai < 0 ? '(' + numData + ')' : numData)
  }
}

const timeWhatsapp = (value) => {
  const diffDay = moment().diff(value, 'days')

  if (diffDay === 0) {
    return dateFormat(value, 'HH:mm')
  } else if (diffDay === 1) {
    return 'Yesterday'
  } else {
    return dateFormat(value, 'DD/MMM/YYYY')
  }
}

function durationTimeCall (milliseconds) {
  const d = moment.duration(milliseconds || 0, 'milliseconds')
  return (
    String(d.hours()).padStart(2, '0') + ':' + 
    String(d.minutes()).padStart(2, '0') + ':' + 
    String(d.seconds()).padStart(2, '0') + '.' + 
    String(d.milliseconds()).padStart(2, '0')
  )
}

export { toMoney, moment, dateFormat, monthFormat, timeWhatsapp, durationTimeCall }
